import { render, staticRenderFns } from "./RequestScoreModal.vue?vue&type=template&id=12d987a3&scoped=true&"
import script from "./RequestScoreModal.vue?vue&type=script&lang=js&"
export * from "./RequestScoreModal.vue?vue&type=script&lang=js&"
import style0 from "./RequestScoreModal.vue?vue&type=style&index=0&id=12d987a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d987a3",
  null
  
)

export default component.exports